module.exports = __webpack_public_path__ + "img/poster-en20x10.7e6baa15.jpg";